export enum BankProviders {
  klarna = 'klarna',
  ibanity = 'ibanity',
  finAPI = 'finAPI',
  accountable = 'accountable',
  creditCard = 'credit-card',
  tink = 'tink',
  swan = 'swan',
}

export enum BankStatus {
  stable = 'stable',
  beta = 'beta',
  dev = 'dev',
}

export enum BankFieldType {
  iban = 'iban',
  email = 'email',
}

export type BankField = {
  type: BankFieldType;
  name: string;
  format?: string;
  hint?: string;
};

export type Bank = {
  id: string | number;
  name: string;
  provider: BankProviders;
  fields: BankField[];
  bic: string;
  status: BankStatus;
  logoUrl?: string; // only available for ibanity
  fullLogoUrl?: string;
  index?: number;
  minBuildNumber?: number;
  maintenance: boolean;
  city?: string; // only available for finAPI
  financialInstitutionSlug?: string;
  financialInstitutionName?: string;
  popular?: boolean;
  groupDisplayName?: string;
};

export enum BankAccountTypes {
  mainAccount = 'main_account',
  taxReserveAccount = 'tax_reserve_account',
  external = 'external',
}

export enum CustomSubAccountIconEnum {
  GLASSES = 'glasses',
  MONEY = 'money',
  CHAIR = 'chair',
  CAKE = 'cake',
  HEART = 'heart',
  LAPTOP = 'laptop',
  PRESENT = 'present',
  DIAMOND = 'diamond',
  PLANT = 'plant',
  CHOCOLATE = 'chocolate',
}

export type BankStatement = {
  accountId: string;
  closingDate: string;
  downloadLink: string;
  filetype: 'PDF' | 'CSV';
  openingDate: string;
  period: 'Monthly' | 'Custom';
  status: 'Pending' | 'Available' | 'Failed';
  swanAccountStatementId: string;
  userId: string;
};
